// extracted by mini-css-extract-plugin
export default {"container":"styles-module_container---ExsxG","segmentPicker":"styles-module_segmentPicker---W7GY_"};